<template>
    <div id="historyWindow">
        <h2 style="font-size: 24px;">
            {{ item.carNo }}
        </h2>
        <p style="margin-bottom: 20px;margin-top: 4px">{{ item.address }}</p>
        <Row>
            <Col span="24">
            <ly-form-item label="定位时间">
                {{ item.gpsTime1 }}
            </ly-form-item>
            </Col>
            <Col span="24">
            <ly-form-item label="单位名称">
                {{ item.groupName }}
            </ly-form-item>
            </Col>
            <Col span="12">
            <ly-form-item label="行驶速度">
                {{ item.speed }}km/h
            </ly-form-item>
            </Col>
            <Col span="12">
            <ly-form-item label="发动机">
                {{ item.accStatus1 }}
            </ly-form-item>
            </Col>
            <Col span="12">
            <ly-form-item label="行驶里程">
                {{ item.mileage }}km
            </ly-form-item>
            </Col>


        </Row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            item: {
                "groupName": "深圳来源电子有限公司",
                "deviceNo": "13306208928",
                "simNo": "1441256694744",
                "carNo": "桂A2U5T3",
                "dqcNo": null,
                "driverName": null,
                "personName": null,
                "orgX": 108.777584,
                "orgY": 21.833346,
                "returnX": 108.78150313230157,
                "returnY": 21.830644374457265,
                "address": '广东省深圳市龙岗区平湖街道华南城大道123号码2号交易中心广场3座2单元5东5漏4321',
                "speed": 0,
                "mileage": 9881.2,
                "altitude": 3,
                "direction": 7,
                "directionDegree": 272,
                "temperature": "0.0",
                "electricity": null,
                "oil": 0,
                "flag": 1,
                "accStatus": 1,
                "deviceStatus": 4,
                "eventDesc": "|视频信号丢失报警|网络信号26|卫星颗数31",
                "gpsTime": 1715656912000,
                "recordTime": 1715656914000,
                "startParkTime": 1715656912000,
                "endParkTime": 1715656942000,
                "parkDuration": 30,
                "locateLng": 108.78150313230157,
                "locateLat": 21.830644374457265,
                "gpsTime1": "2024-05-14 11:21:52",
                "accStatus1": "启动"
            }
        }
    },
    methods: {
        reach(v) {
       
            var pointList = [
                {
                    x: v.orgX,
                    y: v.orgY,
                },
            ];
            this.utils.jiexi(pointList).then((data) => {
                this.item.address = data[0].address;
            });
            this.item = v;
        }
    }
}
</script>
<style>
#historyWindow {
    width: 240px;
    height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/video/historyWindow.vue